
export const copyDataToClipboard = (data)=> navigator?.clipboard?.writeText(data);